import React from 'react';

const Footer = () => (
  <footer className="bg-brand-charcoal text-brand-vintage py-20 px-6 border-t border-brand-vintage/5">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-16 text-center md:text-left">
      <div className="md:col-span-2">
        <h3 className="font-serif text-3xl mb-6 tracking-tighter">Padua Weddings</h3>
        <p className="font-sans text-brand-vintage/50 font-light text-base leading-relaxed max-w-sm mb-8">
          A historic Southern California estate, offering elegant indoor and outdoor spaces for weddings and events in the scenic foothills of Claremont.
        </p>
        <div className="flex justify-center md:justify-start space-x-6">
          <a href="https://www.instagram.com/paduaweddings/" target="_blank" rel="noopener noreferrer" className="text-[10px] uppercase tracking-widest text-brand-bronze hover:text-brand-vintage transition-colors font-bold">Instagram</a>
          <a href="https://www.facebook.com/paduaweddings" target="_blank" rel="noopener noreferrer" className="text-[10px] uppercase tracking-widest text-brand-bronze hover:text-brand-vintage transition-colors font-bold">Facebook</a>
          <a href="https://www.tiktok.com/@paduaweddings" target="_blank" rel="noopener noreferrer" className="text-[10px] uppercase tracking-widest text-brand-bronze hover:text-brand-vintage transition-colors font-bold">TikTok</a>
        </div>
      </div>
      <div className="flex flex-col space-y-3">
        <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-bronze mb-4 font-bold">Connect</h4>
        <a href="tel:909-624-8628" className="font-sans text-brand-vintage/70 hover:text-brand-vintage transition-colors text-sm font-light">909-624-8628</a>
        <a href="mailto:paduahillstheatre@gmail.com" className="font-sans text-brand-vintage/70 hover:text-brand-vintage transition-colors text-sm font-light">paduahillstheatre@gmail.com</a>
        <p className="font-sans text-brand-vintage/50 text-xs mt-4 leading-loose tracking-wide font-light">
          4467 Padua Ave<br />Claremont, CA 91711
        </p>
      </div>
      <div className="flex flex-col space-y-3">
        <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-bronze mb-4 font-bold">Navigation</h4>
        {['Home', 'Weddings', 'Catering', 'Gallery', 'Contact'].map(item => (
          <a key={item} href={`#${item.toLowerCase()}`} className="font-sans text-brand-vintage/70 hover:text-brand-vintage transition-colors text-sm font-light">{item}</a>
        ))}
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-brand-vintage/5 flex flex-col md:flex-row justify-between items-center gap-4">
      <p className="text-[9px] text-brand-vintage/30 uppercase tracking-[0.2em] font-light">
        &copy;{new Date().getFullYear()} Padua Weddings. Timeless Excellence since 1930.
      </p>
      <div className="flex space-x-8">
        <a href="#" className="text-[9px] text-brand-vintage/30 uppercase tracking-[0.2em] hover:text-brand-vintage transition-colors">Privacy</a>
        <a href="#" className="text-[9px] text-brand-vintage/30 uppercase tracking-[0.2em] hover:text-brand-vintage transition-colors">Terms</a>
      </div>
    </div>
  </footer>
);

export default Footer;